import { UserGuideOptions } from './user-guide-options';

export class UserGuide {
    public id: number | null;
    public name: string;
    public translatedName?: string;
    public created_date: Date;
    public created_by: string;
    public modified_date: Date | null;
    public modified_by: string | null;
    public application: string;
    public trigger_type: string;
    public trigger_value: string;
    public options: UserGuideOptions
}
